import { createAction } from "redux-actions";
import * as types from "./constants";
import { apiGet } from "../../util/api";

export const siteDataFetchRequest = createAction(types.SITE_DATA_FETCH_REQUEST);
export const siteDataFetchSuccess = createAction(types.SITE_DATA_FETCH_SUCCESS);
export const siteDataFetchError = createAction(types.SITE_DATA_FETCH_ERROR);

export const siteDataFetch = () => dispatch => {
  dispatch(siteDataFetchRequest());
  apiGet(`/eims/views/output/sites?latitude!=null&longitude!=null&limit=0`)
    .then(res => res.json())
    .then(json => dispatch(siteDataFetchSuccess(json)))
    .catch(err => dispatch(siteDataFetchError(err)));
};
